import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchProviderField,
    ISearchRequestSubset, SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_Period_Type_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_PERIODM_ID:   {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    PERIOD_TYPE_ID:      {type: SearchProviderFieldType.string, renderOptions: { columnName: 'ID', columnResourceName: 'colPeriodTypeId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PERIOD_TYPE_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    MDSET_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Master Data Set', columnResourceName: 'colPeriodTypeMDSet', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256 }
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

var PeriodTypeSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_PERIODM_ID',
        id_ui: 'PERIOD_TYPE_ID',
        name:  'PERIOD_TYPE_NAME'},


    searchProviderFields: vUI_Period_Type_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_PeriodType_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var PeriodTypeSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "PeriodTypeSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'PERIOD_TYPE_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'PERIOD_TYPE_NAME', renderOptions: { }},
        { profileFilterName: 'Master Data Set', searchProviderFieldId: 'MDSET_NAME', renderOptions: {} },

    ],  // ISearchFields
    profileDisplayFields: [
        'PERIOD_TYPE_ID','PERIOD_TYPE_NAME', 'MDSET_NAME',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: PeriodTypeSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var PeriodTypeSearch: ISearch = {
    searchName: "Find PeriodType",
    renderOptions: { ui5ResourceId: "PeriodTypeSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [PeriodTypeSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("PeriodTypeBO", "PeriodType", PeriodTypeSearch, "Period Type Search")

export {PeriodTypeSearch}